import { window } from "global";
import React, { useState, useEffect } from "react";
import { useLocation, matchPath, Link } from "react-router-dom";
import { useGlobal } from "reactn";
import { useUserPremiumState } from "lib/hooks/userHooks";
import MediaQuery from "components/MediaQuery";
import CountdownTimer from "components/CountdownTimer";
import bannerYasuo from "images/onlyguides/banner/banner_yasuo.png";
import bannerLux from "images/onlyguides/banner/banner_lux.png";
import bannerJinx from "images/onlyguides/banner/banner_jinx.png";
import bannerAkali from "images/onlyguides/banner/banner_akali.png";
import bannerZeri from "images/onlyguides/banner/banner_zeri.png";
import { ReactComponent as IconX } from "svg/x.svg";
import { ReactComponent as OGBoxLogo } from "svg/onlyguides-box-logo.svg";
import { ReactComponent as OGTextLogo } from "svg/onlyguides-text-logo.svg";

import { OG_CONTEST_ALERT_LIMIT, OG_CONTEST_DEADLINE } from "lib/constants";

export const bannerImages = [bannerYasuo, bannerLux, bannerJinx, bannerAkali];

function getRandomImage() {
  return bannerImages[Math.floor(Math.random() * bannerImages.length)];
}

function isHidden(pathname) {
  return matchPath(pathname, {
    path: ["/support-us", "/about", "/faq", "/privacy-policy", "/privacy-shield", "/careers", "/terms-of-service"],
    exact: true,
    strict: false,
  });
}

const OG_BANNER_COOKIE = "og-banner";

const UpcomingView = (props) => {
  const { bannerImage } = props;

  return (
    <div className="onlyguides-banner onlyguides-banner_upcoming">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE">
        <div className="bg-image">
          <img src={bannerImage} />
        </div>
      </MediaQuery>
      <OGBoxLogo className="og-box-logo" />
      <div className="text-box">
        <span>
          We’re hosting a{" "}
          <strong style={{ color: "#3273FA" }}>
            <i>$24,000</i>
          </strong>{" "}
          guide writing contest.
        </span>
      </div>
      <a
        className="btn-blue btn-blue_hover og-promos_button"
        href="https://www.onlyguides.com/guide/s12-kickoff-contest-24000-over-two-months-31-1-2022-185158?utm_source=UGG&utm_campaign=Banner"
        target="_blank"
      >
        View Contest Details
      </a>
      {/* <IconX className="x-icon" onClick={onHide} /> */}
    </div>
  );
};

const Upcoming = () => {
  // const [show, setShow] = useState(false);
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  const [bannerImage, setBannerImage] = useState(getRandomImage());

  const location = useLocation();
  const hidden = isHidden(location.pathname);

  // useEffect(() => {
  //   setShow((window && localStorage.getItem(OG_BANNER_COOKIE)) !== "hide");
  // }, [])

  useEffect(() => {
    setBannerImage(getRandomImage);
  }, [location.pathname]);

  // const onHide = () => {
  //   if (window) {
  //     localStorage.setItem(OG_BANNER_COOKIE, "hide");
  //   }
  //   setShow(false);
  // }

  if (!window || hidden || loggingIn || isPremium) {
    return null;
  }

  return <UpcomingView bannerImage={bannerImage} />;
};

const SubmissionView = (props) => {
  return (
    <div className="onlyguides-banner onlyguides-banner_submission">
      <div className="bg-image">
        <img src={bannerZeri} />
        <div className="gradient" />
      </div>
      <div className="flex-center" style={{ position: "relative" }}>
        <OGTextLogo className="og-text-logo" />
        <div className="text-box">
          <span>
            <i>
              &nbsp; has <strong style={{ color: "#3273FA" }}>$24,000</strong> in prizes.
            </i>
          </span>
        </div>
        <a
          className="btn-blue btn-blue_hover og-promos_button"
          href="https://www.onlyguides.com/guide/s12-kickoff-contest-24000-over-two-months-31-1-2022-185158?utm_source=UGG&utm_campaign=Banner2"
          target="_blank"
        >
          Submit Now
        </a>
        <div className="divider" />
        <CountdownTimer endDate={OG_CONTEST_DEADLINE} autoAlert={OG_CONTEST_ALERT_LIMIT} />
      </div>
    </div>
  );
};

const Submission = () => {
  const [loggingIn] = useGlobal("loggingIn");
  const { isPremium } = useUserPremiumState();
  const location = useLocation();
  const hidden = isHidden(location.pathname);

  if (!window || hidden || loggingIn || isPremium) {
    return null;
  }

  return <SubmissionView />;
};

export default {
  UpcomingView,
  Upcoming,
  SubmissionView,
  Submission,
};
